import 'twin.macro';
import { EleveMappingResult } from './types/ClassroomActions';
import { PotentialDuplicateRow } from './PotentialDuplicateRow';

interface Props {
  students: EleveMappingResult[];
  classroomId: string;
  onUpdateEleve: ({
    classroomId,
    eleve,
  }: {
    classroomId: string;
    eleve: any;
  }) => void;
}

export function PotentialDuplicatesTable({
  students,
  classroomId,
  onUpdateEleve,
}: Props) {
  return (
    <div tw="space-y-4">
      {students.map(student => (
        <PotentialDuplicateRow
          key={student.id}
          importedEleve={student}
          classroomId={classroomId}
          onUpdateEleve={onUpdateEleve}
        />
      ))}
    </div>
  );
}
